import React from "react";
import { Skeleton, SkeletonProps } from "@mui/material";

function GenieSkeleton(props: SkeletonProps) {
  return <Skeleton {...props} sx={{ ...props.sx, transform: "scale(1, 1)" }} />;
}

export default GenieSkeleton;
